Number.prototype.formatNumber = function(l, c, d, t){
var n = this, 
    l = l == undefined ? "" : l, 
    c = isNaN(c = Math.abs(c)) ? 2 : c, 
    d = d == undefined ? "." : d, 
    t = t == undefined ? "," : t, 
    s = n < 0 ? "-" : "", 
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
    j = (j = i.length) > 3 ? j % 3 : 0;
    return l + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

Array.prototype.pushUniqueDate = function (el) {
    var n = this;
    if (! Array.isArray(n)) { return false; }

    if (n.length === 0) {
        n.push(el);
    } else {
        for (let i = 0; i < n.length; i++){
            if (n[i].short === el.short) { return false; }
        }
        n.push(el);
    }
};

Array.prototype.pushUnique = function (el, sort) {
    var n = this;
    if (! Array.isArray(n)) { return false; }

    if (n.length === 0) {
        n.push(el);
    } else {
        for (let i = 0; i < n.length; i++){
            if (n[i] === el) { return false; }
        }
        n.push(el);
    }
    if (sort) this.sort();
};